import React from 'react';
import { EMOJIS, EmojiCode } from './types';

interface EmojiPickerProps {
  selectedEmoji: EmojiCode | null;
  onEmojiSelect: (emoji: EmojiCode) => void;
  disabled?: boolean;
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({
  selectedEmoji,
  onEmojiSelect,
  disabled = false,
}) => {
  // Split emojis into two rows for better layout with many emojis
  const firstRow = EMOJIS.slice(0, 6);
  const secondRow = EMOJIS.slice(6);

  const renderEmojiButton = ({ code, emoji, label }: typeof EMOJIS[number]) => (
    <button
      data-track="reaction_emoji"
      key={code}
      onClick={() => onEmojiSelect(code)}
      disabled={disabled}
      className={`
        text-2xl sm:text-3xl p-2 sm:p-3 rounded-lg transition-all
        min-w-[44px] min-h-[44px]
        hover:bg-surface-active dark:hover:bg-gray-700
        focus:outline-none focus:ring-2 focus:ring-primary-500
        disabled:opacity-50 disabled:cursor-not-allowed
        ${selectedEmoji === code ? 'bg-primary-100 dark:bg-primary-900 ring-2 ring-primary-500' : ''}
      `}
      aria-label={`React with ${label}`}
      title={label}
    >
      {emoji}
    </button>
  );

  return (
    <div className="flex flex-col gap-1 p-3 sm:p-4">
      <div className="flex justify-center gap-1 sm:gap-2">
        {firstRow.map(renderEmojiButton)}
      </div>
      <div className="flex justify-center gap-1 sm:gap-2">
        {secondRow.map(renderEmojiButton)}
      </div>
    </div>
  );
};
